export default __webpack_public_path__ + "static/media/team119.7718c791.JPG";